import Image from "next/image";
// CMS-supplied hrefs are emitted verbatim - do NOT swap this for @repo/ui/navigation.
// The CMS localizes its own URLs (e.g. "cl/es/centro-de-ayuda/") and also returns
// external/relative ones, so prefixing here would double or corrupt the locale.
import Link from "next/link";

import {
  Briefcase,
  Building2,
  ChevronRight,
  CircleDollarSign,
  CreditCard,
  Package2,
  PlaneTakeoff,
  Users,
} from "lucide-react";

import allianceAA from "@repo/ui/assets/logos/alliance-aa.png";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@repo/ui/components/ui/accordion";

const benefitList = [
  { icon: <Users size={16} />, label: "Group reservations" },
  { icon: <CircleDollarSign size={16} />, label: "Discount Club" },
  { icon: <PlaneTakeoff size={16} />, label: "Jetsmart Go" },
  { icon: <CreditCard size={16} />, label: "CUSTOMERS BANK STATE" },
  { icon: <Building2 size={16} />, label: "Portal Companies" },
  { icon: <Briefcase size={16} />, label: "Agencies portal" },
  { icon: <Package2 size={16} />, label: "Jetsmart packs" },
];

const programs = [
  { id: 1, text: "Know more of the alliance", link: "/alliance" },
  { id: 2, text: "Program AADVANTAGE®", link: "/advantage" },
];
export default function MobileBenefits() {
  return (
    <div data-testid="mobile-benefits-section">
      <Accordion
        type="single"
        collapsible
        className="bg-brand-blue w-full rounded-sm"
        data-testid="alliance-accordion"
      >
        <AccordionItem value="american-alliance " data-testid="alliance-accordion-item">
          <AccordionTrigger
            className="rounded-sm px-2 text-sm font-semibold text-white"
            data-testid="alliance-accordion-trigger-btn"
          >
            <div className="flex items-center justify-start gap-2" data-testid="alliance-header">
              <Image
                src={allianceAA}
                alt="Alliance with American Airline"
                width={32}
                height={32}
                data-testid="alliance-logo"
              />
              <span data-testid="alliance-title-lbl">Alliance with American Airlines</span>
            </div>
          </AccordionTrigger>
          <AccordionContent className="space-y-2 p-4" data-testid="alliance-accordion-content">
            <div className="grid grid-cols-2 gap-4" data-testid="programs-grid">
              {programs.map((program) => (
                <div
                  key={program.id}
                  className="bg-brand-blue flex h-auto flex-col border border-white px-6 py-2 text-center text-white shadow-sm"
                  data-testid={`alliance-program-${program.id}`}
                >
                  <span
                    className="text-sm font-semibold"
                    data-testid={`alliance-program-text-${program.id}`}
                  >
                    {program.text}
                  </span>
                  <Link
                    href={program.link}
                    className="mx-auto mt-2 flex items-center font-normal"
                    data-testid={`alliance-program-link-${program.id}`}
                  >
                    Ver más <ChevronRight size={14} className="ml-auto" />
                  </Link>
                </div>
              ))}
            </div>
          </AccordionContent>
        </AccordionItem>
      </Accordion>

      <ul className="space-y-2" data-testid="benefits-list">
        {benefitList.map((item) => (
          <li
            key={item.label}
            className="flex items-center gap-3 rounded-md transition-colors hover:bg-gray-100"
            data-testid={`benefit-item-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
          >
            <div
              className="text-brand-blue bg-brand-bluish-gray rounded-full p-2"
              data-testid={`benefit-icon-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              {item.icon}
            </div>
            <span
              className="text-sm text-gray-800"
              data-testid={`benefit-${item.label.toLowerCase().replace(/\s+/g, "-")}-lbl`}
            >
              {item.label}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
